<template>
  <div id="app" class="mw9 center ph3 ph6-ns pv5">
    <div class="flex flex-wrap nl3 nr3">
      <div class="w-100 w-40-l ph3 mb5">
        <div v-if="currentStep === 1">
          <h2 class="f2 f2-l lh-title navy mt0 mb3">
            ¡Conviertete en una profesional de Limpieza!
          </h2>
          <p class="f3-ns lh-copy blue mt0 mb4">
            Completa el siguiente formulario y empieza tu proceso con la empresa
            lider en limpieza.
          </p>
          <div class="aspect-ratio aspect-ratio--16x9">
            <iframe
              src="https://www.youtube.com/embed/4Xjus13cClY"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowfullscreen
              class="aspect-ratio--object cover"
            ></iframe>
          </div>
        </div>
        <div v-else-if="currentStep == 2" class="dn db-l">
          <h2 class="f2 f2-l lh-title navy mt0 mb4">
            Beneficios de estar en Kipper
          </h2>
          <ul class="w-100 list f4 lh-copy pl0 mv0">
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Vacaciones Pagadas y prima vacacional
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Aguinaldo
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Seguro de gastos médicos
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Prestamos Personales
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              ¡Ya no tienes que buscar trabajo, te llenamos tus días de
              servicios!
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Bono de productividad
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Capacipaticon y Apoyo personal
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Crecimiento personal y profesional
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Bono de puntualidad
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Apoyo para pasajes
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Premios por tu desempeño
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Capacitación
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              Y muchas cosas más… ¡Atrévete a cambiar tu vida!
            </li>
            <li class="mb3">
              <span class="w1 dib">
                <svg
                  role="img"
                  aria-label="Kipper Icon"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 83.3 85.7"
                >
                  <path
                    fill="#000E8F"
                    d="M60.2 65.5c-3.5-2.5-6-9-11.2-14.3 17.3-3.2 26.7-14.5 25.8-23C73.7 18.3 63.6 17 63.6 17c.7 6.1-4.1 21.8-23.5 27.3 4.2-6.7 8.4-14.7 7.9-20.3-.7-8.9-13.3-9-13.3-9-.3 2.6-3.5 8-4.7 10.8-1.2 2.9-13.4 23.8-15.5 35.2C11.9 75.3 23 75 23 75s.3-6.8 11.6-22.4c3.3 0 4.4 22.6 22.5 22.6 5.8 0 10-3.3 12.4-6-3.7 0-6.2-1.4-9.3-3.7z"
                  ></path>
                </svg>
              </span>
              ¡Aquí te esperamos, es muy facil convertirte en Kipper!
            </li>
          </ul>
        </div>
        <div v-else>
          <h2 class="f2 f2-l lh-title navy mt0 mb4">
            Felicidades estas a un paso de ser una Kipper
          </h2>
          <p class="f3-ns lh-copy blue mt0 mb4">
            Estas siendo preseleccionada y pasaremos por los últimos datos para
            tener tu expediente completo y evitar que llenes físicamente tu
            solicitud de empleo.
          </p>
          <img
            src="./assets/contactanos-ahora-agencia.jpg"
            alt="Contactanos ahora"
          />
        </div>
      </div>
      <div class="w-100 w-60-l pl3 pr3 pl5-l pr0-l">
        <ValidationObserver v-slot="{ handleSubmit, failed }" tag="div">
          <form
            ref="form"
            @submit.prevent="handleSubmit(onSubmit)"
            class="ba br2 b--near-white pa3 shadow-4 bg-white"
          >
            <fieldset class="bn pa0">
              <keep-alive>
                <template v-if="currentStep === 1">
                  <PreRegister v-bind:preData="prospecto.preDatos" />
                </template>
              </keep-alive>
            </fieldset>
            <div v-if="failed" class="ba f6 fw3 mb4 pa3 red">
              Algunos campos no fueron llenados correctamente, corrije los
              campos en rojo para poder continuar.
            </div>
            <button
              ref="submit"
              v-bind:disabled="prospecto.isSubmitDisable"
              type="submit"
              class="
                  bg-animate bg-yellow hover-bg-light-yellow
                  navy pv3 ph4 br-pill fw6 no-underline flex
                  items-center justify-center f4 bn w-100 mb3 pointer"
            >
              Enviar Solicitud
            </button>
          </form>
        </ValidationObserver>
      </div>
    </div>
  </div>
</template>

<script>
import { extend, configure } from 'vee-validate'
import {
  required,
  email,
  digits,
  is,
  length,
  alpha_num as alphaNum
} from 'vee-validate/dist/rules'
import axios from 'axios'
import PreRegister from './components/PreRegister.vue'

// Validator Rules
extend('email', {
  ...email,
  message: 'Formato de email invalido'
})
extend('is', {
  ...is,
  message: fieldName => {
    if (fieldName === 'identificacionOficial') {
      return 'Debes contar con una identificación oficial (IFE o INE) actualizada para continuar en el proceso'
    }
    return `Este valor no es valido`
  }
})
extend('required', {
  ...required,
  message: 'Campo obligatorio'
})
extend('digits', {
  ...digits,
  message: 'Este campo debe de contener {length} digitos'
})
extend('length', {
  ...length,
  message: 'Este campo debe de contener {length} digitos'
})
extend('alphaNum', {
  ...alphaNum,
  message: 'El caracter escrito es invalido'
})
configure({
  classes: {
    invalid: 'b--red'
  }
})

export default {
  name: 'App',
  components: {
    PreRegister
  },
  data() {
    return {
      prospecto: {
        date: '',
        time: '',
        isSubmitDisable: false,
        preDatos: {
          nombre: '',
          tel: '',
          fechaNacimiento: '',
          modalidad: '',
          genero: '',
          perfil: '',
          ciudadTrabajo: '',
          docs: [],
          experiencia: '',
          domicilio: {
            estado: '',
            municipio: ''
          },
          referenciasLaborales: {
            primera: {
              lugarDeTrabajo: '',
              sueldo: ''
            }
          },
          terminosCondiciones: ''
        }
      },
      currentStep: 1,
      formTopPosition: ''
    }
  },
  methods: {
    onSubmit() {
      // Disable button
      this.prospecto.isSubmitDisable = true
      this.$refs.submit.classList.remove(
        'bg-animate',
        'bg-yellow',
        'hover-bg-light-yellow',
        'pointer'
      )
      this.$refs.submit.innerText = 'Enviando Solicitud…'

      // Set Date & Time
      this.prospecto.date = new Date().toLocaleDateString()
      this.prospecto.time = new Date().toLocaleTimeString()

      axios
        .post('https://api.kippermx.com/reclutamiento/v4/', {
          prospecto: this.prospecto
        })
        .then(response => {
          console.log(response)
          window.location.href =
            'https://empleadasdomesticas.mx/reclutamiento-exitoso/'
        })
        .catch(error => {
          console.log(error)
        })
    }
  }
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;500&display=swap');
#app {
  font-family: 'Montserrat', sans-serif;
}
</style>
